<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Historic Timesheets" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row mb-3" v-if="Object.keys(timesheets_invoices.old).length > 0">
          <div class="col-6">
            <button @click.prevent="old_timesheets" class="btn orcaBtn grey_bg w-100 sm_btn">Old Portal</button>
          </div>
          <div class="col-6">
            <button @click.prevent="new_timesheets" class="btn orcaBtn w-100 sm_btn">New Portal</button>
          </div>
        </div>
        <div class="row" v-if="timesheet_type === 'old'">
          <div class="col-12">
            <hr class="mt-0 mb-0">
            <h5 class="text-uppercase mb-3 mt-3">Timesheets submitted through the Old Portal</h5>
            <hr class="mt-0 mb-3">
          </div>
        </div>
        <div class="row">
          <div class="col-12 show_timesheets" v-if="Object.keys(timesheets).length > 0">
            <div id="ts_menu">
              <div class="companies" v-if="show_ts_companies">
                <div class="company" v-for="c in timesheets.companies" @click.prevent="select_ts_company(c)">
                  <div class="company_details">
                    <strong>{{ c.company_name }}</strong><br>
                    <span><i class="fas fa-history"></i>&nbsp; {{ Object.keys(timesheets.timesheets[c.company_id])[0] | formatDate }}</span>
                  </div>
                  <div class="chevron">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>
              <div class="weeks_container" v-if="show_ts_timesheets">
                <div id="back" @click.prevent="back_to_companies">
                  <i class="fas fa-chevron-left"></i>
                </div>
                <div class="weeks" v-if="company_timesheets !== null">
                  <div v-if="timesheet_type === 'new'" class="week" v-for="(w, t) in timesheets.timesheets[company_timesheets]" @click.prevent="select_ts_week(w, t)">
                    <strong class="week_date">{{ t | formatDate }}</strong>
                    <div class="chevron">
                      <i class="fas fa-chevron-right"></i>
                    </div>
                  </div>
                  <div v-if="timesheet_type === 'old'" class="week" v-for="(w, t) in timesheets.timesheets[company_timesheets]" @click.prevent="select_old_ts_week(w, t)">
                    <strong class="week_date">{{ t | formatDate }}</strong>
                    <div class="chevron">
                      <i class="fas fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="timesheet_type === 'old'" class="timesheet">
              <div class="row" v-if="company_name !== null">
                <div class="col-12">
                  <h4 class="bp_color">{{ company_name }}</h4>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12">
                  <p class="font-weight-bold pt-0 mb-2"><i class="fas fa-arrow-right"></i> Select Company</p>
                </div>
              </div>
              <div v-if="old_preview_setup !== null" class="row">
                <div class="col-12">
                  <h5><span class="font-weight-normal">Timesheet Instructions for week ending :</span> {{ old_preview_ts.submission_week }}</h5>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-xl-6">
                      <strong class="d-inline-block" style="width: 150px;">Job Title : </strong>
                      <span v-if="old_preview_ts.job_title !== null">{{ old_preview_ts.job_title }}</span>
                    </div>
                    <div class="col-xl-6">
                      <strong class="d-inline-block" style="width: 150px;">Pay Rate : </strong>
                      <span v-if="old_preview_ts.pay_rate !== null">{{ old_preview_ts.pay_rate | currency }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="bp_color">Totals</h5>
                  <div class="row">
                    <div class="col-xl-7">
                      <strong style="display: inline-block; width: 250px;">Before Additions and Deductions :</strong>
                      <span>{{ (old_preview_ts.pay_rate * old_preview_ts.total_units) | currency }}</span><br>
                      <strong style="display: inline-block; width: 250px;">Total Gross :</strong>
                      <span class="bp_color font-weight-bold">{{ old_preview_ts.gross | currency }}</span><br>
                      <span class="font-italic" style="font-size: 0.65rem;">(not including deductions for Fees and Tax)</span>
                    </div>
                    <div class="col-xl-5">
                      <strong style="display: inline-block; width: 150px;">Additions :</strong><span>{{ old_preview_ts.addition_amount | currency }}</span><br>
                      <strong style="display: inline-block; width: 150px;">Deductions :</strong><span>{{ old_preview_ts.deduction_amount | currency }}</span><br>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="bp_color">Sites</h5>
                  <div class="row timesheet_sites">
                    <div class="col-12">
                      <div class="site">
                        <div class="row">
                          <div class="col-xl-6">
                            <div class="row">
                              <div class="col-12" v-for="(setup, k) in old_preview_setup" v-if="k.includes('_name') && setup !== null">
                                <strong class="d-inline-block" style="width: 165px;">{{ setup }} :</strong> {{
                                  (old_preview_ts['site_' + k.split('_')[1] + '_units'] *
                                      old_preview_ts.pay_rate) |
                                      currency
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-xl-6">
                            <div class="row" v-if="old_preview_ts.addition_amount !== '0' && old_preview_ts.deduction_amount !== '0'">
                              <div class="col-12">
                                <strong>Adjustments Description :</strong>
                              </div>
                              <div class="col-12">
                                {{ old_preview_ts.adjustment_description }}
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12">
                  <p class="font-weight-bold pt-0 mb-2"><i class="fas fa-arrow-right"></i> Select Timesheet Week End Date</p>
                </div>
              </div>
            </div>
            <div v-if="timesheet_type === 'new'" class="timesheet">
              <div class="row" v-if="company_name !== null">
                <div class="col-12">
                  <h4 class="bp_color">{{ company_name }}</h4>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12">
                  <p class="font-weight-bold pt-0 mb-2"><i class="fas fa-arrow-right"></i> Select Company</p>
                </div>
              </div>
              <div v-if="preview_date !== null" class="row">
                <div class="col-12">
                  <h5><span class="font-weight-normal">Timesheet Instructions for week ending :</span> {{ preview_date | formatDate }}</h5>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-xl-6">
                      <strong class="d-inline-block" style="width: 150px;">Job Title : </strong>
                      <span v-if="preview_ts[0].job_title !== null">{{ preview_ts[0].job_title }}</span>
                      <span class="font-italic" v-else>Assigned to Job Orders with different Job Titles</span><br>
                      <!-- -->
                      <strong class="d-inline-block" style="width: 150px;">Pay Type : </strong>
                      <span v-if="preview_ts[0].pay_type !== null">{{ preview_ts[0].pay_type }}</span>
                      <span class="font-italic" v-else>Assigned to Job Orders with different Pay Types</span>
                    </div>
                    <div class="col-xl-6">
                      <strong class="d-inline-block" style="width: 150px;">Rate Type : </strong>
                      <span v-if="preview_ts[0].rate_type !== null">{{ preview_ts[0].rate_type }}</span>
                      <span class="font-italic" v-else>Assigned to Job Orders with different Rate Types</span><br>
                      <!-- -->
                      <strong class="d-inline-block" style="width: 150px;">Pay Rate : </strong>
                      <span v-if="preview_ts[0].pay_rate !== null">{{ preview_ts[0].pay_rate | currency }}</span>
                      <span class="font-italic" v-else>Assigned to Job Orders with different Pay Rates</span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="bp_color">Totals</h5>
                  <div class="row">
                    <div class="col-xl-7">
                      <strong style="display: inline-block; width: 250px;">Before Additions and Deductions :</strong><span>{{ calc_tbad() | currency }}</span><br>
                      <strong style="display: inline-block; width: 250px;">Total Gross :</strong><span class="bp_color font-weight-bold">{{ calc_tg() | currency }}</span><br>
                      <span class="font-italic" style="font-size: 0.65rem;">(not including deductions for Fees and Tax)</span>
                    </div>
                    <div class="col-xl-5">
                      <strong style="display: inline-block; width: 150px;">Pre Tax Additions :</strong><span>{{ calc_tpta() | currency }}</span><br>
                      <strong style="display: inline-block; width: 150px;">Post Tax Additions :</strong><span>{{ calc_tpota() | currency }}</span><br>
                      <strong style="display: inline-block; width: 150px;">Pre Tax Deductions :</strong><span>{{ calc_tptd() | currency }}</span><br>
                      <strong style="display: inline-block; width: 150px;">Post Tax Deductions :</strong><span>{{ calc_tpotd() | currency }}</span><br>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="bp_color">Sites</h5>
                  <div class="row timesheet_sites">
                    <div class="col-12" v-for="(s, k) in this.preview_ts[0]" v-if="(k !== 'worker_id' && k !== 'first_name' && k !== 'surname' && k !== 'genius_submitted'
                    && k !== 'internal_finance_ref' && k !== 'job_title' && k !== 'pay_type' && k !== 'rate_type' && k !== 'pay_rate') && s.invoice_total !== 0">
                      <div class="site">
                        <div class="row">
                          <div class="col-xl-6">
                            <h5 class="bp_color mb-0">{{ s.order_ref }}</h5>
                            <h5 class="mb-0">{{ s.location }}</h5>
                            <p class="pt-0 mb-2">{{ s.rate_type }} - {{ s.pay_rate | currency }} [{{ s.pay_type }}]</p>
                          </div>
                          <div class="col-xl-6">
                            <strong style="display: inline-block; width: 280px">Total Before Additions and Deductions :</strong> {{
                              s.total_before_additions_deductions |
                                  currency
                            }}<br>
                            <strong style="display: inline-block; width: 280px">Total Gross :</strong> <span class="bp_color">{{ s.invoice_total | currency }}</span><br>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-xl-6">
                            <div class="day" v-for="d in s.timesheet_pay">
                              <strong class="d-inline-block" style="width: 170px;">{{ d.pay_date | format_ts_period_date_plus_day }} : </strong> {{ d.price | currency }}
                            </div>
                          </div>
                          <div class="col-xl-6" style="font-size: 0.65rem">
                            <strong class="d-inline-block" style="width: 170px;">Pre Tax Additions</strong>{{ calc_pta(s) | currency }}<br>
                            <strong class="d-inline-block" style="width: 170px;">Post Tax Additions</strong>{{ calc_ppta(s) | currency }}<br>
                            <strong class="d-inline-block" style="width: 170px;">Pre Tax Deductions</strong>{{ calc_ptd(s) | currency }}<br>
                            <strong class="d-inline-block" style="width: 170px;">Post Tax Deductions</strong>{{ calc_potd(s) | currency }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12">
                  <p class="font-weight-bold pt-0 mb-2"><i class="fas fa-arrow-right"></i> Select Timesheet Week End Date</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12">
      <b-card header="Invoices" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row" v-if="this.timesheet_type === 'old'">
          <div class="col-12">
            <h5 class="mb-3">The old timesheet portal did not allow submission of invoices for work by the worker.</h5>
          </div>
        </div>
        <div class="row" v-if="this.timesheet_type === 'new' && this.timesheets.length !== 0">
          <div class="col-12">
            <h5 class="mb-3">The below are Invoices submitted for work completed by the worker.</h5>
          </div>
          <div class="col-12">
            <div class="tableFixHead">
              <table>
                <thead>
                <tr>
                  <!--                  <th>Worker Invoice Date</th>-->
                  <th style="width: 165px;">For Work Completed Week Ending</th>
                  <th>End Client Name</th>
                  <th style="width: 71px">View</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="invoice in timesheets.invoices">
                  <!--                  <td>{{invoice.worker_invoice_date | formatDate}}</td>-->
                  <td>{{ invoice.timesheet_record.for_work_end_week_date | formatDate }}</td>
                  <td>{{ invoice.end_client_name }}</td>
                  <td>
                    <button class="btn orcaBtn greenBtn sm_btn" @click.prevent="show_invoice(invoice, invoice.worker_name, 'sdf')"><i class="fas fa-file-invoice"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <modal_show_invoice v-if="$store.state.client_timesheets.show_invoice_modal"></modal_show_invoice>
  </div>
</template>

<script>
import modal_show_invoice from 'components/pages/clients/timesheets/modals/show_invoice';

export default {
  name: "timesheets_invoices",
  props: ['timesheets_invoices'],
  components: {
    modal_show_invoice
  },
  data() {
    return {
      timesheet_type: 'new',
      timesheets: this.timesheets_invoices.new,
      show_ts_companies: true,
      show_ts_timesheets: false,
      company_name: null,
      company_timesheets: null,
      preview_ts: [],
      preview_date: null,
      old_preview_ts: [],
      old_preview_setup: null
    }
  },
  methods: {
    old_timesheets() {
      this.timesheet_type = 'old'
      this.timesheets = this.timesheets_invoices.old;

      this.show_ts_companies = true;
      this.show_ts_timesheets = false;
      this.company_name = null;
      this.company_timesheets = null;
      this.preview_ts = [];
      this.preview_date = null;
      this.old_preview_ts = [];
      this.old_preview_setup = null;
    },
    new_timesheets() {
      this.timesheet_type = 'new'
      this.timesheets = this.timesheets_invoices.new;

      this.show_ts_companies = true;
      this.show_ts_timesheets = false;
      this.company_name = null;
      this.company_timesheets = null;
      this.preview_ts = [];
      this.preview_date = null;
      this.old_preview_ts = [];
      this.old_preview_setup = null;
    },
    select_ts_company(company) {
      this.company_name = company.company_name
      this.company_timesheets = company.company_id
      this.show_ts_companies = false
      this.show_ts_timesheets = true
    },
    back_to_companies() {
      this.show_ts_companies = true;
      this.show_ts_timesheets = false;
      this.company_name = null;
      this.company_timesheets = null;
      this.preview_ts = [];
      this.preview_date = null;
      this.old_preview_ts = [];
      this.old_preview_setup = null;
    },
    select_ts_week(w, t) {
      this.preview_date = null;
      this.preview_ts = [];
      this.preview_date = t;
      let length = Object.keys(w).length;
      let count = 0;
      Object.values(w).forEach(r => {
        if (!this.preview_ts.some(e => e.worker_id === r.worker_id)) {
          this.preview_ts.push({
            'worker_id': r.worker_id,
            'first_name': r.assignment.worker.person.first_name,
            'surname': r.assignment.worker.person.surname,
            'genius_submitted': r.company_submitted,
            'internal_finance_ref': r.assignment.worker.internal_finance_ref,
            'job_title': null,
            'pay_type': null,
            'rate_type': null,
            'pay_rate': null,
            [r.order_job_id]: {
              'addition_pre_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
              'addition_post_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
              'deduction_pre_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
              'deduction_post_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
              'timesheet_pay': r.timesheet_pay,
              'total_units': r.total_hours,
              'total_before_additions_deductions': r.total_price,
              'invoice_total': r.total_pay_amount,
              //
              'job_title': r.order_job.rel_order_position.job_title,
              'pay_type': r.assignment.position_rate.pay_type,
              'rate_type': r.assignment.position_rate.rate_type,
              'pay_rate': r.assignment.position_rate.pay_amount,
              'location': r.order_job.rel_order_location.job_address_full,
              'order_ref': r.order_job.order_ref
            }
          })
        }
        else {
          let existing = this.preview_ts.find(pr => pr.worker_id === r.worker_id);

          if (existing.worker_id === r.worker_id) {
            if (!r.company_submitted) {
              existing.genius_submitted = r.company_submitted;
            }
          }

          if (!(r.order_job_id in existing)) {
            existing[r.order_job_id] = {
              'addition_pre_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
              'addition_post_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
              'deduction_pre_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
              'deduction_post_tax': r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
              'timesheet_pay': r.timesheet_pay,
              'total_units': r.total_hours,
              'total_before_additions_deductions': r.total_price,
              'invoice_total': r.total_pay_amount,
              //
              'job_title': r.order_job.rel_order_position.job_title,
              'pay_type': r.assignment.position_rate.pay_type,
              'rate_type': r.assignment.position_rate.rate_type,
              'pay_rate': r.assignment.position_rate.pay_amount,
              'location': r.order_job.rel_order_location.job_address_full,
              'order_ref': r.order_job.order_ref
            }
          }
          else {
            existing[r.order_job_id].addition_pre_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29));
            existing[r.order_job_id].addition_post_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30));
            existing[r.order_job_id].deduction_pre_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31));
            existing[r.order_job_id].deduction_post_tax.push(r.timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32));
            existing[r.order_job_id].timesheet_pay.push(r.timesheet_pay);
            existing[r.order_job_id].total_units += r.total_hours;
            existing[r.order_job_id].total_before_additions_deductions += r.total_price;
            existing[r.order_job_id].invoice_total += r.total_pay_amount;
          }
        }
        count++;
        if (count === length) {
          // loop per worker day array to check if job_title, pay type, rate type and pay rate are all the same
          for (let j = 0; j < this.preview_ts.length; j++) {
            for (let key in this.preview_ts[j]) {
              if (key !== 'first_name' && key !== 'internal_finance_ref'
                  && key !== 'surname' && key !== 'worker_id'
                  && key !== 'job_title' && key !== 'pay_type'
                  && key !== 'rate_type' && key !== 'pay_rate' && key !== 'genius_submitted') {
                // job title
                if (this.preview_ts[j].job_title === null) {
                  this.preview_ts[j].job_title = this.preview_ts[j][key].job_title;
                }
                else if (this.preview_ts[j].job_title !== this.preview_ts[j][key].job_title) {
                  this.preview_ts[j].job_title = false;
                }
                // pay type
                if (this.preview_ts[j].pay_type === null) {
                  this.preview_ts[j].pay_type = this.preview_ts[j][key].pay_type;
                }
                else if (this.preview_ts[j].pay_type !== this.preview_ts[j][key].pay_type) {
                  this.preview_ts[j].pay_type = false;
                }
                // rate type
                if (this.preview_ts[j].rate_type === null) {
                  this.preview_ts[j].rate_type = this.preview_ts[j][key].rate_type;
                }
                else if (this.preview_ts[j].rate_type !== this.preview_ts[j][key].rate_type) {
                  this.preview_ts[j].rate_type = false;
                }
                // pay rate
                if (this.preview_ts[j].pay_rate === null) {
                  this.preview_ts[j].pay_rate = this.preview_ts[j][key].pay_rate;
                }
                else if (this.preview_ts[j].pay_rate !== this.preview_ts[j][key].pay_rate) {
                  this.preview_ts[j].pay_rate = false;
                }
              }
            }
          }
        }
      })
    },
    select_old_ts_week(w, t) {
      this.old_preview_ts = [];
      this.old_preview_setup = null;
      this.old_preview_ts = w[0];
      this.old_preview_setup = this.timesheets.ts_setups[w[0].company_id].filter(tss => tss.created_at < w[0].created_at)[0];
    },
    // Preview Totals
    calc_tbad() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          total += this.preview_ts[0][key].total_before_additions_deductions;
        }
      }
      return total;
    },
    calc_tg() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          total += this.preview_ts[0][key].invoice_total;
        }
      }
      return total;
    },
    calc_tpta() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          if (this.preview_ts[0][key].hasOwnProperty('addition_pre_tax')) {
            for (let k = 0; k < this.preview_ts[0][key].addition_pre_tax.length; k++) {
              total += this.preview_ts[0][key].addition_pre_tax[k].amount;
            }
          }
        }
      }
      return total;
    },
    calc_tpota() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          if (this.preview_ts[0][key].hasOwnProperty('addition_post_tax')) {
            for (let k = 0; k < this.preview_ts[0][key].addition_post_tax.length; k++) {
              total += this.preview_ts[0][key].addition_post_tax[k].amount;
            }
          }
        }
      }
      return total;
    },
    calc_tptd() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          if (this.preview_ts[0][key].hasOwnProperty('deduction_pre_tax')) {
            for (let k = 0; k < this.preview_ts[0][key].deduction_pre_tax.length; k++) {
              total += this.preview_ts[0][key].deduction_pre_tax[k].amount;
            }
          }
        }
      }
      return total;
    },
    calc_tpotd() {
      let total = 0;
      for (let key in this.preview_ts[0]) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' && key !== 'genius_submitted'
            && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type' && key !== 'rate_type') {
          if (this.preview_ts[0][key].hasOwnProperty('deduction_post_tax')) {
            for (let k = 0; k < this.preview_ts[0][key].deduction_post_tax.length; k++) {
              total += this.preview_ts[0][key].deduction_post_tax[k].amount;
            }
          }
        }
      }
      return total;
    },
    // Sites
    calc_pta(site) {
      let total = 0;
      for (let i = 0; i < site.addition_pre_tax.length; i++) {
        total += site.addition_pre_tax[i].amount
      }
      return total;
    },
    calc_ppta(site) {
      let total = 0;
      for (let i = 0; i < site.addition_post_tax.length; i++) {
        total += site.addition_post_tax[i].amount
      }
      return total;
    },
    calc_ptd(site) {
      let total = 0;
      for (let i = 0; i < site.deduction_pre_tax.length; i++) {
        total += site.deduction_pre_tax[i].amount
      }
      return total;
    },
    calc_potd(site) {
      let total = 0;
      for (let i = 0; i < site.deduction_post_tax.length; i++) {
        total += site.deduction_post_tax[i].amount
      }
      return total;
    },
    // INVOICES
    show_invoice(invoice, first_name, surname) {
      this.$store.commit('SHOW_INVOICE_MODAL', {
        first_name: first_name,
        surname: surname,
        invoice: {
          assignment: invoice.timesheet_record.assignment,
          timesheet_pay: invoice.timesheet_record.timesheet_pay,
          timesheet_worker_invoice: invoice
        }
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'show_invoice_modal'));
    }
  }
}
</script>

<style scoped lang="scss">
.tableFixHead {
  overflow-y:    auto;
  max-height:    500px;
  margin-bottom: 20px;
  border:        1px solid #ccc;

  thead {
    th {
      position: sticky;
      top:      0;
    }
  }

  table {
    border-collapse: collapse;
    width:           100%;
  }

  th, td {
    padding: 8px 16px;
    border:  1px solid #ccc;
  }

  th {
    background: #eee;
  }
}

.show_timesheets {
  min-height: 515px;

  #ts_menu {
    height:     500px;
    min-height: 500px;
    max-height: 500px;
    overflow:   scroll;
    display:    inline-block;
    width:      200px;
    border:     1px solid $bc_2;
    position:   absolute;
  }

  .timesheet {
    height:         500px;
    min-height:     500px;
    max-height:     500px;
    width:          calc(100% - 200px);
    overflow:       hidden;
    display:        inline-block;
    vertical-align: top;
    margin-left:    200px;
    padding-left:   15px;

    .timesheet_sites {
      display:    inline-block;
      height:     214px;
      max-height: 214px;
      min-height: 214px;
      overflow:   scroll;
      width:      100%;

      .site {
        background:    lighten($bc_5, 10%);
        margin-bottom: 10px;
        padding:       10px;

        .day {
          font-size: 0.65rem;
        }
      }
    }
  }

  .companies {
    height:     500px;
    min-height: 500px;
    max-height: 500px;
    overflow:   scroll;
    display:    inline-block;
    width:      200px;
    position:   absolute;

    .company {
      display:       flex;
      border-bottom: 1px solid $bc_5;

      &:last-of-type {
        border-bottom: none;
      }

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: lighten($bc_5, 15%);
        cursor:           pointer;
      }

      .company_details {
        display:  inline-block;
        width:    224px;
        padding:  5px;
        position: relative;

        span {
          color: $bc_3
        }

        &:before {
          content:      "";
          position:     absolute;
          right:        0;
          top:          5px;
          width:        30px;
          border-right: 1px solid $bc_5;
          bottom:       5px;
        }
      }

      .chevron {
        justify-content: center;
        align-content:   center;
        flex-direction:  column;
        display:         flex;
        text-align:      center;
        width:           25px;
        align-items:     center;
      }

      .company_details, .chevron {
        vertical-align: middle;
      }
    }

  }

  .weeks_container {
    height:  100%;
    display: flex;
    width:   100%;

    #back {
      justify-content:  center;
      align-content:    center;
      flex-direction:   column;
      display:          flex;
      text-align:       center;
      width:            25px;
      align-items:      center;
      vertical-align:   middle;
      height:           498px;
      background-color: lighten($bc_5, 15%);
      position:         fixed;

      &:after {
        content:      "";
        position:     absolute;
        right:        0;
        top:          2px;
        width:        2px;
        border-right: 1px solid $bc_5;
        bottom:       2px;
      }

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: lighten($bc_5, 10%);
        cursor:           pointer;
      }
    }

    .weeks {
      width:       calc(100% - 25px);
      margin-left: 25px;
      display:     block;

      .week {
        display:       flex;
        border-bottom: 1px solid $bc_5;
        padding:       10px 0px 10px 10px;
        position:      relative;

        .week_date {
          display:  inline-block;
          width:    224px;
          padding:  5px;
          position: relative;

          &:after {
            content:      "";
            position:     absolute;
            right:        0;
            top:          2px;
            width:        2px;
            border-right: 1px solid $bc_5;
            bottom:       2px;
          }
        }

        .chevron {
          justify-content: center;
          align-content:   center;
          flex-direction:  column;
          display:         flex;
          text-align:      center;
          width:           50px;
          align-items:     center;
        }

        .week_date, .chevron {
          vertical-align: middle;
        }

        &:hover, &:focus, &:active, &:active:focus, &.active:focus,
        &.focus, &:active.focus, &.active.focus {
          background-color: lighten($bc_5, 10%);
          cursor:           pointer;
        }
      }
    }
  }
}
</style>
